export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
  functionKey: process.env.REACT_APP_FUNCTION_KEY || '',
  finalChecksFunctionKey: process.env.REACT_APP_FINAL_CHECKS_FUNCTION_KEY || '',
  internalCommsEmail: process.env.REACT_APP_INTERNAL_COMMS_EMAIL || 'darrylashton@bidfood.co.uk',
  // Azure AD / MSAL Configuration
  azureAd: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    tenantId: process.env.REACT_APP_AZURE_TENANT_ID || '',
    authority: process.env.REACT_APP_AZURE_AUTHORITY || '',
  },
};